import {FETCH_XMAS} from '../actions/types';


const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_XMAS:
            return action.payload;
        default:
            return state;
    }
}